import React from 'react';
import Auto from '../assets/images/auto-icon copy.svg';

export default () => {
  return <img src={Auto} alt="" />;
};
